import { render, staticRenderFns } from "./BatchManagementTable.vue?vue&type=template&id=05840f48&"
import script from "./BatchManagementTable.vue?vue&type=script&lang=js&"
export * from "./BatchManagementTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports